import React from 'react';
import { connect } from 'react-redux';
import ProviderSidebarLinks from './ProviderSidebarLinks';
import StaffSidebarLinks from './StaffSidebarLinks';

const AgentPortalSidebar = ({ currentAgent, pendingReferralsCount, ...rest }) => {
  switch (currentAgent.currentEmployment.type) {
    case 'ProviderEmployment':
      return (
        <ProviderSidebarLinks
          currentEmployment={currentAgent.currentEmployment}
          pendingReferralsCount={pendingReferralsCount}
          {...rest}
        />
      );

    case 'StaffEmployment':
      return (
        <StaffSidebarLinks
          currentEmployment={currentAgent.currentEmployment}
          pendingReferralsCount={pendingReferralsCount}
          {...rest}
        />
      );

    default:
      return null;
  }
};

function mapStateToProps(state) {
  return {
    pendingReferralsCount: state.referrals.pendingReferralsCount,
  };
}

export default connect(mapStateToProps)(AgentPortalSidebar);
